export default "__VITE_ASSET__CWJvG9DU__"